import { Wordmark } from "./wordmark";

/**
 * The board band before we know who is asking: the wordmark only — nothing
 * that needs a session. Used while the session check runs and when the server
 * cannot be reached, so the desk always sees the app, never a blank page.
 * Same blue and ribbon as the signed-in band.
 */
export function BareBand() {
	return (
		<header className="sticky top-0 z-30 bg-board text-white">
			<div className="flex min-h-[3.5rem] items-center px-[1rem] py-[0.375rem] lg:px-[1.5rem]">
				<span className="flex min-h-touch min-w-0 items-center">
					<Wordmark />
				</span>
			</div>
			<div aria-hidden="true" className="mses-ribbon" />
		</header>
	);
}
